import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Button, Container, Modal } from 'react-bootstrap';
import { MdOutlineAddCircle, MdDelete, MdMode } from 'react-icons/md'
import { ToastContainer, toast } from 'react-toastify';
import { reject } from 'lodash';

import api from '../../../services/client';
import styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom'
import routes from '../../routes';

const ActionButton = styled.div`
text-align: center;
svg {
  width: 25px;
  height: 25px;
  margin: auto 5px;
  cursor: pointer;
}
`;

const Title = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    margin: auto;
    font-size: 40px;
    font-weight:500;
`;

const AddButton = styled(Link)`
margin: 15px 0;
border: 1px solid #0A3BB4;
`

function AllCompaines(props) {
  const history = useHistory();
    const [allCompaines, setAllCompanies] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState('');

  const handleClose = () => {setShow(false); setSelectedCompany('');};
  const handleShow = (company) => {
    setShow(true);
    setSelectedCompany(company);
  }
  const handleOnYes= async () => {
    await api.deleteCompay(selectedCompany.CompanyId).then((result) => {
      handleClose();
      toast.success("company deleted successfully", {
        onOpen: () => setAllCompanies(reject(allCompaines,selectedCompany)) 
      });
      ;
    })
  }


    useEffect(async () => {
        await api.getAllCompaines().then((result) => {
            setAllCompanies(result.data)
         })
    }, [])

    const deleteCompany = async company => {
      await api.deleteCompay(company.CompanyId).then((result) => {
        toast.success("company deleted successfully", {
          onOpen: () => setAllCompanies(reject(allCompaines,company)) 
        });
        ;
      })
    }

    const editCompany = company => {
      history.push(routes.ADMINUPDATECOMPANY.replace(':companyId', company.CompanyId))
    }


    const actionsFormatter = (cell, row) =>  
        <ActionButton>
            <MdMode fill='#0A3BB4' onClick={() => editCompany (row)} /> 
            <MdDelete fill='#f50d0d' onClick={() => handleShow(row)} />
        </ActionButton>;
    
      const columns = [
        { dataField: 'CompanyId', text: 'Id', sort: true,  headerStyle: () => {
          return { width: "10%", overflow:"hidden", textOverflow:'ellipsis' };
        }  },
        { dataField: 'CompanyName', text: 'Name', sort: true, headerStyle: () => {
          return { overflow:"hidden", textOverflow:'ellipsis' };
        }       
        },
        { dataField: 'Email', text: 'Email Id', sort: true, headerStyle: () => {
          return { overflow:"hidden", textOverflow:'ellipsis' };
        }  },
        // { dataField: 'CareerLink', text: 'Career Link', sort: true,
        //     formatter:((data) => {return data ? <a href={data} target='_blank'>{data}</a> : ''}) ,
        //     headerStyle: () => {
        //       return { overflow:"hidden", textOverflow:'ellipsis' };
        //     } 
        // },
        { dataField: 'IsFeatured', text: 'Is Featured', sort: true,
            formatter:((data) => {return data ? 'Yes' : 'No'}) ,
            headerStyle: () => {
              return { width: "15%",overflow:"hidden", textOverflow:'ellipsis' };
            } 
        },
        { dataField: 'CreatedDate', text: 'Created Date', sort: true, formatter:((data) => {return new Date(data).toLocaleDateString()}) },
        {
            dataField: 'actions',
            text: 'Actions',
            isDummyField: true,
            csvExport: false,
            formatter: actionsFormatter,
            headerStyle: () => {
              return { width: "15%", overflow:"hidden", textOverflow:'ellipsis' };
            } 
          },
      ];
    
      const defaultSorted = [{
        dataField: 'CompanyId',
        order: 'asc'
      }];
    
      const pagination = paginationFactory({
        page: 1,
        sizePerPage: 10,
        lastPageText: '>>',
        firstPageText: '<<',
        nextPageText: '>',
        prePageText: '<',
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
          console.log('page', page);
          console.log('sizePerPage', sizePerPage);
        },
        onSizePerPageChange: function (page, sizePerPage) {
          console.log('page', page);
          console.log('sizePerPage', sizePerPage);
        },
        sizePerPageList: [
            {text:"10", value: 10},
            {text:"25", value: 25},
            {text:"50", value: 50}
        ]
      });
    
      const { SearchBar } = Search;

    return allCompaines && allCompaines.length > 0 && (
      
        <Container>
          <Title> Companies List</Title> 
            <ToolkitProvider
        bootstrap4
        keyField='CompanyId'
        data={allCompaines}
        columns={columns}
        search
      >
        {
          props => (
            <div>
              <div style={{width:'100%'}}>
              
              <SearchBar {...props.searchProps} delay={350} />
              <AddButton variant="light" to={routes.ADDCOMPANY} className='btn btn-light'> <MdOutlineAddCircle fill ='#0A3BB4'/> Add New </AddButton>
              </div>
              {/* <ClearSearchButton {...props.searchProps} /> */}
              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={pagination}
                {...props.baseProps}
                striped
                rowStyle={{overflowWrap:'break-word'}}
              />
            </div>
          )
        }
        </ToolkitProvider>
         
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header>
            <Modal.Title>Delete Company</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do you want to delete?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleOnYes}>
              Yes
            </Button>
            <Button variant="primary" onClick={handleClose}>
              No
            </Button>
          </Modal.Footer>
        </Modal>

          <ToastContainer position="bottom-right" autoClose={2000} closeOnClick theme='colored' />
        </Container>
    )
}

AllCompaines.propTypes = {

}

export default AllCompaines

